import { convertFromHTML, ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

export function draftjs_EditorStateFromHtml(markup: string): EditorState {
  const blocksFromHTML = convertFromHTML(markup);
  const state = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap
  );
  return EditorState.createWithContent(state);
}

export function draftjsMapEditorStateBackToHtml(editorState: EditorState): string {
  const rawContentState = convertToRaw(editorState.getCurrentContent());
  const markup = draftToHtml(rawContentState);
  return markup;
}
